
import { Heart, Stethoscope, Pill, Users, Activity, Smile } from 'lucide-react';
import { Product } from './types';

export const healthcareProducts: Product[] = [
  {
    id: 'medical-device-management',
    title: 'Medical Device Management',
    subtitle: 'Comprehensive device tracking',
    description: 'Complete medical device management system with tracking, maintenance scheduling, MHRA compliance monitoring, and inventory control for UK healthcare providers.',
    icon: Stethoscope,
    image: '/src/assets/medical-device-management-hero.jpg',
    category: 'Healthcare & Medicine',
    status: 'Available',
    features: [
      'Device inventory tracking & asset register',
      'Maintenance scheduling & PAT testing',
      'MHRA compliance monitoring & UKCA marking',
      'Usage analytics & performance metrics',
      'Warranty management & service records',
      'Calibration tracking & certification',
      'NHS reporting tools & CQC compliance',
      'Integration with NHS systems & trusts'
    ],
    pricing: { setup: 55000, monthly: 2530 },
    color: 'from-blue-500 to-teal-600',
    businessTypes: ['#healthcare', '#medical-devices', '#compliance', '#inventory', '#maintenance']
  },
  {
    id: 'telemedicine-platform',
    title: 'Telemedicine Platform',
    subtitle: 'Virtual healthcare solution',
    description: 'Secure telemedicine platform with video consultations, remote monitoring, e-prescriptions, and integration with EHR systems.',
    icon: Heart,
    image: 'https://images.unsplash.com/photo-1530497610245-94d3c16cda28?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Healthcare & Medicine',
    status: 'Available',
    features: [
      'Video consultations',
      'Remote monitoring',
      'E-prescriptions',
      'EHR integration',
      'Appointment scheduling',
      'Secure messaging',
      'Payment processing',
      'Reporting tools'
    ],
    pricing: { setup: 65000, monthly: 2990 },
    color: 'from-red-500 to-pink-600',
    businessTypes: ['#telemedicine', '#virtual-care', '#remote-health', '#ehr', '#consultations']
  },
  {
    id: 'pharmacy-management-system',
    title: 'Pharmacy Management System',
    subtitle: 'Efficient pharmacy operations',
    description: 'Complete pharmacy management system with prescription processing, inventory control, patient management, and automated dispensing.',
    icon: Pill,
    image: 'https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Healthcare & Medicine',
    status: 'Available',
    features: [
      'Prescription processing',
      'Inventory management',
      'Patient profiles',
      'Automated dispensing',
      'Drug interaction alerts',
      'Billing & insurance',
      'Reporting tools',
      'Compliance monitoring'
    ],
    pricing: { setup: 48000, monthly: 2208 },
    color: 'from-orange-500 to-amber-600',
    businessTypes: ['#pharmacy', '#medications', '#prescriptions', '#inventory', '#dispensing']
  },
  {
    id: 'patient-relationship-management',
    title: 'Patient Relationship Management',
    subtitle: 'Enhanced patient engagement',
    description: 'Comprehensive PRM solution with patient portals, appointment reminders, feedback collection, and personalized communication tools.',
    icon: Users,
    image: 'https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Healthcare & Medicine',
    status: 'Available',
    features: [
      'Patient portals',
      'Appointment reminders',
      'Feedback surveys',
      'Personalized messaging',
      'Loyalty programs',
      'Referral management',
      'Analytics dashboard',
      'Integration capabilities'
    ],
    pricing: { setup: 42000, monthly: 1932 },
    color: 'from-purple-500 to-indigo-600',
    businessTypes: ['#patient-care', '#crm', '#engagement', '#communication', '#loyalty']
  },
  {
    id: 'fitness-wellness-platform',
    title: 'Fitness & Wellness Platform',
    subtitle: 'Holistic health management',
    description: 'Integrated fitness and wellness platform with workout tracking, nutrition planning, mental health support, and personalized coaching.',
    icon: Activity,
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Healthcare & Medicine',
    status: 'Available',
    features: [
      'Workout tracking',
      'Nutrition planning',
      'Mental health support',
      'Personalized coaching',
      'Progress monitoring',
      'Community challenges',
      'Wearable integration',
      'Gamification elements'
    ],
    pricing: { setup: 38000, monthly: 1748 },
    color: 'from-green-500 to-teal-600',
    businessTypes: ['#fitness', '#wellness', '#nutrition', '#mental-health', '#coaching']
  },
  {
    id: 'dental-practice-management',
    title: 'Dental Practice Management System',
    subtitle: 'Complete dental practice solution',
    description: 'Comprehensive dental practice management with patient scheduling, treatment planning, digital records, billing, and imaging integration.',
    icon: Smile,
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Healthcare & Medicine',
    status: 'Available',
    features: [
      'Patient scheduling & appointments',
      'Treatment planning & charting',
      'Digital patient records',
      'Billing & insurance processing',
      'X-ray & imaging integration',
      'Prescription management',
      'Recall & reminder systems',
      'Reporting & analytics'
    ],
    pricing: { setup: 45000, monthly: 2070 },
    color: 'from-blue-500 to-cyan-600',
    businessTypes: ['#dental', '#dentistry', '#patient-care', '#medical-records', '#appointments']
  }
];
